import "./AppSettings.scss";
import { Popover } from "antd";
import { useState } from "react";
import { AppSettingsContent } from "./components/AppSettingsContent.tsx";

export const AppSettings = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="app-settings">
      <Popover
        styles={{ body: { padding: "16px" } }}
        arrow={false}
        trigger="click"
        placement="bottomRight"
        open={open}
        onOpenChange={setOpen}
        content={<AppSettingsContent closePopover={() => setOpen(false)} />}
      >
        <div className={`icon-circle ${open ? "icon-circle-open" : "icon-circle-closed"}`}>
          <i className="fa-solid fa-gear gear-icon"></i>
        </div>
      </Popover>
    </div>
  );
};
